import { useState, useContext, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import authAxios from "../../components/authAxios";
import { Link, useNavigate } from "react-router-dom";

import Pagination from '@mui/material/Pagination';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Chip from '@mui/material/Chip';
import { VisibilityOutlined } from "@mui/icons-material";
import BorderColorSharpIcon from '@mui/icons-material/BorderColorSharp';

import { Tabs } from "antd";

import { format } from 'date-fns';

import EllipsisMenu from "../../components/EllipsisMenu";
import Loading from "../../components/Loading";
import Pillchip from "../../components/Pillchip";
import DashboardHeader from "../../components/DashboardHeader";

import MeterNew from "./MeterNew";
import MeterEdit from "./MeterEdit";
import CustomSearchBar from "../../components/CustomSearchBar";
import './Rental.css'


const Meters = () => {
    const [page, setPage] = useState(1);
    const [pagecount, setPageCount] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [property, setProperty] = useState("");
    const [meter, setMeter] = useState(null);

    const [status, setStatus] = useState("");
    const [searchText, setSearchText] = useState('');

    const { TabPane } = Tabs;

    const onChange = (key) => {
      };

    const { data: meters, ...rest } = useQuery({
        queryKey: ['meters', property, status, page, searchText],
        queryFn: async () => {
          const response = await authAxios.get(`/rentals/meters/?status=${status}&property=${property}&search=${searchText}&page=${page}`);
          setPageCount(response.data.page_count);
          return response.data.results;
        },
      });

    const handlePageChange = (event, value) => {
        setPage(value);
    };



    return (
            <div className="dashboard-main">                
               
                <section className="dashboard-content">
                    <div className="dashboard-content-header-nav">
                        <DashboardHeader dashboardTitle="Utility Meters" dashboardPreTitle="Rentals" removeBorder={true}/>
                        <div className="dashboard-content-header-nav-icons">
                            <CustomSearchBar 
                                searchText={searchText}
                                setSearchText={setSearchText}
                            />
                        </div>
                    </div>
                    <Tabs defaultActiveKey="All" onChange={onChange}>
                        <TabPane tab="All" key="All">
                            <FilterMeters 
                                status="" 
                                setProperty={setProperty}
                                property={property}
                                meters={meters}   
                                setIsEditModalOpen={setIsEditModalOpen}  
                                setMeter={setMeter}
                            />
                        </TabPane>
                        <TabPane tab="Active" key="010">
                            <FilterMeters 
                                status="010" 
                                setProperty={setProperty}
                                property={property}
                                meters={meters}     

                            />                 
                        </TabPane>
                        <TabPane tab="Inactive" key="020">
                            <FilterMeters 
                                status="020" 
                                setProperty={setProperty}
                                property={property}
                                meters={meters}     

                            />
                        </TabPane >
                  
                    </Tabs>
                    <Pagination 
                        className="custom-mui-pagination"
                        count={pagecount} 
                        page={page} 
                        onChange={handlePageChange} 
                    />
                    <MeterNew 
                        isModalOpen={isModalOpen}
                        setIsModalOpen={setIsModalOpen}
                    />
                    {meter && (
                        <MeterEdit 
                            isModalOpen={isEditModalOpen}
                            setIsModalOpen={setIsEditModalOpen}
                            meter={meter}
                        />
                    )}
                     <Fab className="fab" color="primary" aria-label="add" onClick={()=>{
                        setIsModalOpen(true)}}
                        >
                        <AddIcon />
                    </Fab>
                    {/* <Link to="/dashboard/lease-new" className="nav-link">
                        <Fab className="fab" color="primary" aria-label="add">
                            <AddIcon />
                        </Fab>
                    </Link>  */}

                </section>
            </div>

    )
}
export default Meters

const FilterMeters = ({ 
    status, 
    meters, 
    setProperty, 
    property,
    setMeter,
    setIsEditModalOpen 
}) => {
    const navigate = useNavigate()
    const convertDateTime = (myDateTime) => {
        return format(new Date(myDateTime), 'dd-MM-yyyy HH:mm');
    };

    // const formatReference = (reference) => {
    //     return `${reference.slice(0, 3)}-${reference.slice(3, 9)}-${reference.slice(9)}`;
    // };

    const { data: properties, isLoadingProperties } = useQuery({
        queryKey: ['properties-with-meters'],
        queryFn: async () => {
          const response = await authAxios.get(`/rentals/properties/with-meters`);
          return response.data
        },
    });


    // const ThreeDotsMenu = ({data}) => {    
    //     const [anchorEl, setAnchorEl] = useState(null);    
    //     const handleClick = (e) => {
    //         setAnchorEl(e.currentTarget);
    //     }


    //     const handleClose = () => {
    //         setAnchorEl(null);
    //     }


    //     return(
    //         <>
    //             <IconButton
    //                 aria-label="more"
    //                 id="long-button"
    //                 onClick={handleClick}
    //             >
    //                 <MoreVertIcon />
    //             </IconButton>
    //             <Menu
    //                 id="basic-menu"
    //                 anchorEl={anchorEl}
    //                 open={Boolean(anchorEl)}
    //                 onClose={handleClose}
    //                 MenuListProps={{
    //                 'aria-labelledby': 'basic-button',
    //                 }}
    //             >
    //                 <MenuItem className="styled-threedots-dropdown" >
    //                     <ListItemIcon>
    //                         <VisibilityOutlined/>
    //                     </ListItemIcon>
    //                     <ListItemText onClick={()=>navigate(`/dashboard/meter/${data.id}`)}>
    //                         View
    //                     </ListItemText>
    //                 </MenuItem>
    //             </Menu>
    //         </>
    //     )
    // }

    const menuItems = (selectedMeter) => {
        const baseItems = [
            {
                label: 'View',
                icon: <VisibilityOutlined />,
                onClick: () => {
                    navigate(`/dashboard/meter/${selectedMeter.id}`);
                }
            },
            {
                label: 'Edit',
                icon: <BorderColorSharpIcon />,
                onClick: () => {
                    // navigate(`/dashboard/meter-edit/${meter.id}`);
                    console.log("METER", selectedMeter)
                    setMeter(selectedMeter)
                    setIsEditModalOpen(true);
                }
            },
        ];
        // if (lease.status_code === '020') {
        //     baseItems.push({
        //         label: 'Edit',
        //         icon: <BorderColorSharpIcon />,
        //         onClick: () => {
        //             navigate(`/dashboard/lease-edit`, { state: { lease } });
        //         }
        //     });
        // }

        return baseItems;

    };

    const handleChipClick = (e) => {
        if (e.id){
            setProperty(e.id)
        }
        else{
            setProperty("")
        }
    };

    if (isLoadingProperties) return <Loading loading={true} />;

    return (
        <div className="filter-meters">
            {properties && properties.length>1 && status !== "020" &&
                <div className="chip-list-container">
                    <div className="chip-list">
                        <Chip 
                            className="custom-chip" 
                            sx={{width:75}} 
                            onClick={()=>handleChipClick("All")} 
                            label="All" 
                            variant="outlined"
                            color={property === "" ? "primary" : "default"}

                        />
                        {properties.map(myProperty => (
                            <Chip 
                                className="custom-chip" 
                                key={myProperty.id} 
                                onClick={()=>handleChipClick(myProperty)} 
                                label={myProperty.name} 
                                variant="outlined"
                                color={property === myProperty.id ? "primary" : "default"}
                            />
                        ))
                        }
                    </div>
                </div>
            }
            <table className="styled-table">
                <thead>
                    <tr >
                        <th>Meter No</th>
                        <th>Utility</th>
                        <th>Property</th>
                        <th>Tenant</th>
                        <th>Last Reading</th>
                        <th className="cell-align-right">Price</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>
                {meters && meters.map((meter) => (          
                    <tbody key={meter.id}>
                        <tr>
                            <td>{meter.reference}</td>
                            <td>{meter.sku_name}</td>
                            <td>{meter.property_unit_name}</td>
                            <td>{meter.customer}</td>
                            <td>{meter.last_reading}</td>
                            <td className="cell-align-right">{Number(meter.price).toLocaleString('en-UK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td><Pillchip label={meter.status_name} /></td>
                            <td className='styled-table-menu' >
                                <EllipsisMenu items={menuItems(meter)} />
                            </td>
                        </tr>
                    </tbody>
                ))}
            </table>
        </div>
    );
  };


